import { TVenture } from "src/services/apiEndpoint.types.ts/ventures/ventures.types";
export const initialPostVentureValues: TVenture = {
  // userId: "",
  title: "",
  description: "",
  about: "",
  domain: "",
  otherDomainInput: '',
  ventureStage: "",
  fundingStage: "",
  websiteUrl: "",
  incubatorName: '',
  otherIncubatorName: '',
  coWorkingName: '',
  otherCoWorkingName: '',
  coFounders: [],
  noOfCustomers: { number: "", hidden: false },
  teamSize: { number: "", hidden: false },
  linkCompanyPage: false,
  isHiring: false,
  isSeekingCofounderHiring: false,
  hiring: [],
  logo: "",
  banner: "",
  draft: false
}
